import React from 'react';
import Nav from 'react-bootstrap/Nav'
import { NavLink } from 'react-router-dom';
import {Link} from 'react-scroll'
import './Navigation.css'
import the from './asset/the.png'
const Navigation = () => {

   return (
        <Nav className="navbar navbar-expand-sm bg-dark navbar-dark sticky-top" >
          
          <Link className="navbar-brand" to="gamedikha"><img src={the} height="60" width="70" smooth={true}/></Link>
          
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item">
                <Link className="nav-link" to="home" smooth={true}>
                    <NavLink to='/' >Home</NavLink>
                </Link>
              </li>
              <li className="nav-item">
                  <Link className="nav-link" to="about" smooth={true}>
                    <NavLink to='/about'>About</NavLink>
                  </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="contact" smooth={true}>
                  <NavLink to='/contact'>Contact</NavLink>
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="reg" smooth={true}>
                <NavLink to='/reg'>Register</NavLink>
                </Link>
              </li>

              <li className="nav-item">
              <Link className="nav-link" to="results" smooth={true}>
                <NavLink to='/results'>Results</NavLink>
                </Link>
                
                
              </li>
            </ul>
          </div>
        </Nav>




    );
}

export { Navigation };
